export enum MenuLcvModelCategory {
  pickup = 'รถปิกอัพ',
  suv = 'รถอเนกประสงค์',
}

export enum BuyingTools {
  title = 'เครื่องมือสำหรับการซื้อรถ',
  compare = 'เปรียบเทียบรุ่นรถ',
  calculator = 'คำนวณค่างวด',
  dealer = 'ค้นหาโชว์รูม / ศูนย์บริการ',
  downloadBrochure = 'ดาวน์โหลดโบรชัวร์',
}

export enum NavigationMenuLabel {
  model = 'รุ่นรถอีซูซุ',
  offer = 'ข้อเสนอและไฟแนนซ์',
  service = 'บริการ',
  benefit = 'สิทธิประโยชน์',
  share = 'แชร์สิ่งดีๆ',
  serviceOther = 'บริการอื่นๆ',
  aboutus = 'เกี่ยวกับอีซูซุ',
  online = 'ช่องทางติดต่อออนไลน์',
}
